import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bb9ca83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = {
  key: 0,
  class: "body"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "头像：")
], -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "姓名：")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "用户名：")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "身份证号：")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "手机号码：")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "民族：")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "状态：")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))
const _hoisted_13 = { class: "body-bottom" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "项目名称：")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "参见单位：")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "部门：")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "班组：")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "岗位：")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "角色：")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "邮箱：")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "安全教育资料：")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "认证对比：")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "省平台对比：")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "下发照片：")
], -1))
const _hoisted_25 = { class: "icon" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "照 片 对 比", -1))
const _hoisted_27 = { class: "button" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("拍摄照片")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "省平台人员照片和身份证人员照片对比", -1))
const _hoisted_30 = { class: "submit" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-arrow": "",
      onClickLeft: _ctx.goBack
    }, null, 8, ["title", "onClickLeft"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.userInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _hoisted_4,
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _ctx.userInfo.photoUrl
                }, null, 8, _hoisted_5)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_6,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.name), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.username), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.idNo), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.mobile), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.nation), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_11,
              _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.status ? "正常" : "禁用"), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", null, [
          _hoisted_14,
          _createElementVNode("div", null, _toDisplayString(_ctx.$store.state.project.projectinfo.projectName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_15,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.companyNames), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_16,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.deptNames), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_17,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.teamName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_18,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.stationName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_19,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.roleNames), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_20,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.email), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_21,
          _createElementVNode("div", null, [
            _createVNode(_component_van_uploader, {
              fileList: _ctx.safeFileComputed,
              onClickPreview: _ctx.clickPreview,
              deletable: false,
              "max-count": _ctx.userInfo.safeFile.length
            }, null, 8, ["fileList", "onClickPreview", "max-count"])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_22,
          _createElementVNode("div", null, [
            _createVNode(_component_van_button, {
              onClick: _ctx.compare,
              size: "mini",
              type: "default"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_icon, { name: "comment-o" })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_23,
          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.idCheck === 1 ? "通过" : "不通过"), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_24,
          _createElementVNode("div", null, [
            _createVNode(_component_van_button, {
              onClick: _ctx.syncPersonRowFun,
              size: "mini",
              type: "default"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_icon, { name: "down" })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      onOpen: _ctx.openPopup,
      style: { height: '60%', width: '70%' },
      show: _ctx.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.show) = $event)),
      class: "popup"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_van_icon, {
            name: "cross",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false))
          })
        ]),
        _hoisted_26,
        _createVNode(_component_van_uploader, {
          ref: "loader",
          modelValue: _ctx.uploader,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uploader) = $event)),
          "after-read": _ctx.afterRead,
          "max-count": 1
        }, null, 8, ["modelValue", "after-read"]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_van_button, {
            size: "small",
            onClick: _ctx.takePicture,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_van_button, {
            size: "small",
            type: "default",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = false))
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          }),
          _createVNode(_component_van_button, {
            size: "small",
            type: "primary",
            onClick: _ctx.submit
          }, {
            default: _withCtx(() => [
              _hoisted_32
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["onOpen", "show"])
  ]))
}